import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';

const Box = ({ id, cobrand }) => (
    <div
        style={{
            margin: '10px',
            backgroundColor: 'hsl(0, 0%, 90%)',
            padding: '10px',
            width: 'min-content',
            height: 'min-content',
            borderRadius: '4px',
        }}
    >
        <p style={{ margin: 0 }}>{id} {cobrand}</p>
    </div>
);

Box.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  cobrand: PropTypes.string.isRequired,
};

function ShowCobrandList({ clients, tags, cobrands, setTotalToUpdate, setParentCobrandList }) {
    const [cobrandList, setCobrandList] = useState([]);

    const [, getCobrandIds] = useAxios(
        { url: `internal/cobrand/ids-from-tags`, method: 'POST' },
        { manual: true },
    );
    const noSelections = !clients && !tags && !cobrands;

    const getListOfCobrandIds = async () => {
        if (noSelections) {
            setCobrandList([]);
            if (setParentCobrandList) setParentCobrandList([]);
            if (setTotalToUpdate) setTotalToUpdate(0);
            return;
        }
        const getCobrandIdsData = {
            client: clients || null,
            cobrand: cobrands || null,
            cobrandTag: tags || null,
        };

        if (typeof getCobrandIds !== 'function') {
            console.error("getCobrandIds is not a function", getCobrandIds);
            return;
        }

        let CobrandIds = await getCobrandIds({
            data: getCobrandIdsData,
        });

        CobrandIds.data = CobrandIds?.data || [];

        if (cobrands?.includes(15)) {
            CobrandIds.data.push({ coBrandId: 15, name: 'Global Featured' });
        }

        if (cobrands?.includes(16)) {
            CobrandIds.data.push({ coBrandId: 16, name: 'iGrad Featured' });
        }

        if (cobrands?.includes(17)) {
            CobrandIds.data.push({ coBrandId: 17, name: 'Enrich Featured' });
        }

        setCobrandList(CobrandIds?.data?.sort((a, b) => a.name - b.name));
        if (setParentCobrandList) {
            setParentCobrandList(CobrandIds?.data?.sort((a, b) => a.name.localeCompare(b.name)));
        }
        setTotalToUpdate(CobrandIds?.data?.length || 0);
    };

    useEffect(() => {
        getListOfCobrandIds();
    }, [clients, tags, cobrands]);

    if (noSelections || cobrandList?.length < 1) return null;

    return (
        <div
            style={{
                backgroundColor: '#fff4ce',
                padding: '20px',
                borderRadius: '8px',
                marginTop: '40px',
            }}
        >
            <h3>List of cobrand Id's to be updated</h3>
            <h4>Total cobrands to be updated: {cobrandList.length}</h4>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {cobrandList?.length > 0 && cobrandList.map((item) => <Box cobrand={item.name} id={item.coBrandId} key={item.name} />)}
            </div>
        </div>
    );
}

ShowCobrandList.propTypes = {
    clients: PropTypes.array,
    tags: PropTypes.array,
    cobrands: PropTypes.array,
    setTotalToUpdate: PropTypes.func,
    setParentCobrandList: PropTypes.func,
};

export default ShowCobrandList;
